/**
 * URL of the pdf.js worker script.
 *
 * The worker is served from public/pdf.worker.min.js (copied from pdfjs-dist
 * at the .js extension) to avoid servers blocking .mjs files as
 * application/octet-stream instead of text/javascript.
 *
 * Pass this as the `pdfWorkerSrc` prop of `CurecallDocumentViewer`.
 */
export const PDF_WORKER_SRC = '/pdf.worker.min.js'
